import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconBackProps extends SVGProps<any> {}
export class SVGIconBack extends Component<SVGIconBackProps> {
  render() {
    const { width = 40, height = 40, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-back"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 ${width} ${height}`}
        {...rest}
      >
        <path
          d="M40 20C40 16.0444 38.827 12.1776 36.6294 8.8886C34.4318 5.59962 31.3082 3.03617 27.6537 1.52242C23.9991 0.00866318 19.9778 -0.387402 16.0982 0.384304C12.2186 1.15601 8.65492 3.06082 5.85787 5.85787C3.06082 8.65492 1.15601 12.2186 0.384304 16.0982C-0.387402 19.9778 0.00866318 23.9991 1.52242 27.6537C3.03617 31.3082 5.59962 34.4318 8.8886 36.6294C12.1776 38.827 16.0444 40 20 40C25.3026 39.9943 30.3863 37.8853 34.1358 34.1358C37.8853 30.3863 39.9943 25.3026 40 20V20ZM3.33334 20C3.33334 16.7036 4.31083 13.4813 6.14218 10.7405C7.97354 7.99968 10.5765 5.86347 13.6219 4.60201C16.6674 3.34055 20.0185 3.0105 23.2515 3.65358C26.4845 4.29667 29.4542 5.88402 31.7851 8.21489C34.116 10.5458 35.7033 13.5155 36.3464 16.7485C36.9895 19.9815 36.6595 23.3326 35.398 26.3781C34.1365 29.4235 32.0003 32.0265 29.2595 33.8578C26.5187 35.6892 23.2964 36.6667 20 36.6667C15.5812 36.6618 11.3448 34.9043 8.22025 31.7798C5.0957 28.6552 3.33819 24.4188 3.33334 20ZM20.405 27.0717L18.0483 29.4283L10.9767 22.3567C10.3518 21.7316 10.0007 20.8839 10.0007 20C10.0007 19.1161 10.3518 18.2684 10.9767 17.6433L18.0483 10.5717L20.405 12.9283L15 18.3333L30 18.3333V21.6667L15 21.6667L20.405 27.0717Z"
          fill="white"
        />
      </SVG>
    );
  }
}
